import { Component, Input, OnInit } from '@angular/core';
import { DialogService } from '../../services/dialog.service';
import { DialogWidth } from 'src/app/shared/atlas-dialog/enums/dialog-width.enum';
import { AiAssistantDialogComponent } from '../ai-assistant/ai-assistant-dialog/ai-assistant-dialog.component';
import { AiPromptTemplateLibraryService } from '../../services/ai-prompt-template-library.service';
import { MapLayerStyleService } from 'src/app/shared/atlas-mapping/services/map-layer-style-service';
import { NgZone } from '@angular/core';
import { Store } from '@ngrx/store';
import * as fromCore from 'src/app/core/store';
import { MatDialog } from '@angular/material/dialog';
import { isAiAssistantDialogOpen } from 'src/app/shared/utils/dialog-utils';

@Component({
    selector: 'atlas-layer-description',
    templateUrl: './layer-description.component.html',
    styleUrls: ['./layer-description.component.less'],
    standalone: false
})
export class LayerDescriptionComponent implements OnInit {
  @Input() layer: any;

  isAiAssistantEnabled$ = this.coreStore$.select(fromCore.isAiAssistantEnabled);

  constructor(
    private dialogService: DialogService,
    private aiPromptService: AiPromptTemplateLibraryService,
    private layerStyleService: MapLayerStyleService,
    private coreStore$: Store<fromCore.State>,
    private ngZone: NgZone,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {}

  onAiAssistantClicked(): void {
    // build prompy from legend

    var prompt = '';
    if (
      this.layerStyleService.getSpotlightedDomainsOnLayer(this.layer.id).size >
      0
    ) {
      // loop through spotlighted domains build prompt I am interested in the following layer name list of domains
      const spotlightedDomains =
        this.layerStyleService.getSpotlightedDomainsOnLayer(this.layer.id);
      const layerName = this.layer.props.name;
      const domainsList = Array.from(spotlightedDomains).join(' \n ');
      prompt = `I am interested in the following ${layerName} \n  ${domainsList}. \n Please provide insights or information related to these domains.`;
    } else {
      prompt =
        'Please spotlight the domains in the layer legend, you are interested in chatting about.';
    }

    this.ngZone.run(() => {
      // add prompt to the service
      this.aiPromptService.setCurrentPromptText(prompt);

      if (!isAiAssistantDialogOpen(this.dialog)) {
        this.dialogService.show(AiAssistantDialogComponent, {
          width: DialogWidth.Large,
          panelClass: 'dialog-full-width-height',
          disableClose: true,
          hasBackdrop: false
        });
      }
    });
  }
}
